export const getPrioratData = () => ({
  name: "Priorat",
  country: "Espagne",
  description: "Le Priorat est une région viticole prestigieuse de Catalogne, située dans les montagnes de la Sierra de Montsant. Cette région produit des vins rouges puissants et complexes, principalement à base de Grenache et de Carignan, avec une forte identité terroir.",
  type: "region",
  mapAreas: [
    { region: "Priorat", x: 55, y: 60, color: "#4B164C", size: 3 }
  ],
  statistics: {
    totalArea: "2,000 ha",
    production: "0.8 million hectolitres",
    appellations: "1 DOQ",
    villages: "12 villages",
    exportPercentage: "60%"
  },
  characteristics: {
    climate: "Climat méditerranéen avec influence montagneuse",
    soil: "Sols de schiste noir (llicorella), très pauvres et drainants",
    viticulture: "Viticulture traditionnelle, vignobles en terrasses, vendanges manuelles"
  },
  wineStyles: {
    red: "Vins rouges puissants et complexes, avec des tannins mûrs et une grande concentration",
    white: "Vins blancs secs et aromatiques, avec une forte minéralité",
    rose: "Rosés structurés et complexes",
    sweet: "Vins doux naturels, concentrés et complexes"
  },
  history: "La viticulture dans le Priorat remonte à l'époque romaine. Au Moyen Âge, les monastères ont développé la viticulture. Le XXe siècle a vu la renaissance de la région avec l'émergence de nouveaux domaines. Aujourd'hui, le Priorat est reconnu comme l'une des régions viticoles les plus prestigieuses d'Espagne.",
  foodPairing: "Viandes rouges, gibier, fromages affinés, cuisine catalane traditionnelle",
  subregions: {
    "gratallops": {
      name: "Gratallops",
      description: "Village central du Priorat produisant des vins rouges de grande qualité, avec une forte identité terroir.",
      characteristics: {
        climate: "Climat méditerranéen avec influence montagneuse",
        soil: "Sols de schiste noir (llicorella)",
        viticulture: "Viticulture traditionnelle, vignobles en terrasses"
      },
      grapeVarieties: {
        red: ["Grenache", "Carignan", "Syrah", "Cabernet Sauvignon"],
        white: ["Grenache Blanc", "Macabeo", "Pedro Ximénez"]
      },
      wineStyles: {
        "priorat-gratallops": "Vins rouges puissants et complexes",
        "priorat-blanc-gratallops": "Vins blancs secs et minéraux"
      },
      foodPairing: "Viandes rouges, gibier, fromages affinés, cuisine catalane"
    },
    "porrera": {
      name: "Porrera",
      description: "Village du Priorat produisant des vins rouges structurés et tanniques, avec une forte identité montagneuse.",
      characteristics: {
        climate: "Climat méditerranéen avec influence montagneuse",
        soil: "Sols de schiste noir et de calcaire",
        viticulture: "Viticulture traditionnelle, vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Grenache", "Carignan", "Syrah", "Merlot"],
        white: ["Grenache Blanc", "Macabeo"]
      },
      wineStyles: {
        "priorat-porrera": "Vins rouges structurés et tanniques",
        "priorat-blanc-porrera": "Vins blancs secs et aromatiques"
      },
      foodPairing: "Viandes rouges, gibier, fromages affinés, cuisine traditionnelle"
    },
    "falset": {
      name: "Falset",
      description: "Village du Priorat produisant des vins rouges équilibrés et fruités, avec une forte identité locale.",
      characteristics: {
        climate: "Climat méditerranéen tempéré",
        soil: "Sols de schiste et d'argile",
        viticulture: "Viticulture traditionnelle, rendements limités"
      },
      grapeVarieties: {
        red: ["Grenache", "Carignan", "Syrah", "Cabernet Sauvignon"],
        white: ["Grenache Blanc", "Macabeo", "Pedro Ximénez"]
      },
      wineStyles: {
        "priorat-falset": "Vins rouges équilibrés et fruités",
        "priorat-blanc-falset": "Vins blancs secs et frais"
      },
      foodPairing: "Viandes rouges, volailles, fromages, cuisine méditerranéenne"
    },
    "bellmunt": {
      name: "Bellmunt",
      description: "Village du Priorat produisant des vins rouges et blancs de qualité, avec une forte identité montagneuse.",
      characteristics: {
        climate: "Climat méditerranéen avec influence montagneuse",
        soil: "Sols de schiste noir et de calcaire",
        viticulture: "Viticulture traditionnelle, vignobles en altitude"
      },
      grapeVarieties: {
        red: ["Grenache", "Carignan", "Syrah", "Merlot"],
        white: ["Grenache Blanc", "Macabeo", "Pedro Ximénez"]
      },
      wineStyles: {
        "priorat-bellmunt": "Vins rouges puissants et structurés",
        "priorat-blanc-bellmunt": "Vins blancs secs et minéraux"
      },
      foodPairing: "Viandes rouges, gibier, fromages affinés, cuisine montagneuse"
    }
  }
}); 